import React, { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { api } from "@/lib/api";

// Honest social-proof pill: renders nothing until a real weekly threshold is reached.
export default function SocialProof({ className = "" }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/social/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats?.show) return null;

  return (
    <div
      data-testid="social-proof"
      className={`inline-flex items-center gap-1.5 rounded-full bg-pink-500/10 border border-pink-500/25 text-pink-200 text-xs font-semibold px-3 py-1.5 ${className}`}
    >
      <Flame size={13} className="text-pink-400" />
      {stats.week_count.toLocaleString("fr-FR")} profils analysés cette semaine
    </div>
  );
}
